import { Delegate } from "vendor";
import { __accessCheck, __privateGet, __privateAdd, __privateSet, __privateMethod } from "theme";

let _onCustomisationInputChangedListener, _CustomisationInput_instances, onCustomisationInputChanged_fn;

let CustomisationGHD = class extends HTMLElement {
	constructor() {
		super();
	    __privateAdd(this, _CustomisationInput_instances);
	    __privateAdd(this, _onCustomisationInputChangedListener, __privateMethod(this, _CustomisationInput_instances, onCustomisationInputChanged_fn).bind(this));
	}
	
    connectedCallback() {
	    this.inputElement = this.querySelectorAll('input, select, checkbox')[0];
	    this.inputElement.addEventListener("change", __privateGet(this, _onCustomisationInputChangedListener));
    }
	
    disconnectedCallback() {
	    this.inputElement.removeEventListener("change", __privateGet(this, _onCustomisationInputChangedListener));
    }
	
    get additionalCharge() {
      return this.querySelectorAll('[name="properties[_bundle_id]"]')[0];
    }
	
};

_CustomisationInput_instances = new WeakSet();

_onCustomisationInputChangedListener = new WeakMap();
onCustomisationInputChanged_fn = function() {
	if (this.inputElement.tagName == 'INPUT') {
		if (this.inputElement.value.length > 0) {
			this.additionalCharge.removeAttribute('disabled');
		} else {
			this.additionalCharge.setAttribute('disabled','disabled');
		}
	} else if (this.inputElement.tagName == 'CHECKBOX') {
		if (this.inputElement.checked) {
			this.additionalCharge.removeAttribute('disabled');
		} else {
			this.additionalCharge.setAttribute('disabled','disabled');
		}
	} else if (this.inputElement.tagName == 'SELECT') {
		console.log('SELECT TODO');
	}
};

if (!window.customElements.get("customisation-ghd")) {
  window.customElements.define("customisation-ghd", CustomisationGHD);
}

export {
	CustomisationGHD
};

